import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useApp } from "../context/AppContext";
import { tr } from "../i18n/translations";
import { api } from "../lib/api";

export default function NewsletterPopup() {
  const { lang } = useApp();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("nl_seen") === "1") return;
    // Strategy 1: timer fallback at 25s (long-time visitors)
    const t = setTimeout(() => setOpen(true), 25000);
    // Strategy 2: exit-intent (mouse leaving the top of the viewport = trying to close tab)
    const onLeave = (e) => {
      if (e.clientY <= 0 && localStorage.getItem("nl_seen") !== "1") {
        setOpen(true);
      }
    };
    document.addEventListener("mouseleave", onLeave);
    return () => {
      clearTimeout(t);
      document.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  function close() {
    setOpen(false);
    localStorage.setItem("nl_seen", "1");
  }

  async function submit(e) {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/newsletter", { email, lang });
      setDone(true);
      localStorage.setItem("nl_seen", "1");
      navigator.clipboard?.writeText("BIENVENUE10");
    } catch { /* silent */ }
  }

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-ink/40 backdrop-blur-sm flex items-center justify-center p-6" data-testid="newsletter-popup">
      <div className="bg-white rounded-3xl max-w-md w-full p-8 relative shadow-2xl">
        <button onClick={close} className="absolute top-4 end-4 p-2 rounded-full hover:bg-ivory-200" data-testid="popup-close">
          <X size={18} />
        </button>
        <div className="sticker-coral mb-4">-10%</div>
        <h3 className="font-display text-3xl leading-tight">{tr(lang, "popup_title")}</h3>
        <p className="text-ink-soft text-sm mt-3">{tr(lang, "popup_sub")}</p>
        {done ? (
          <div className="mt-6 bg-sage/30 rounded-2xl p-5 text-center">
            <p className="font-display text-2xl">BIENVENUE10</p>
            <p className="text-xs text-ink-soft mt-2">{tr(lang, "popup_ok")}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input
              data-testid="popup-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={tr(lang, "newsletter_email")}
              className="w-full bg-ivory-200 rounded-full px-5 py-3 text-sm outline-none focus:ring-2 focus:ring-pedablue/20"
            />
            <button data-testid="popup-submit" className="w-full btn-primary justify-center">
              {tr(lang, "popup_btn")}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
